const columns = [
  { title: "Buy/Sell", dataIndex: "action" },
  { title: "Currency Pair", dataIndex: "symbol" },
  { title: "Quantity/Notional", dataIndex: "totalCloseVolume" },
  { title: "Entry Price", dataIndex: "openPrice" },
  { title: "Exit Price", dataIndex: "closePrice" },
  { title: "Entry Time", dataIndex: "openTime" },
  { title: "Exit Time", dataIndex: "closeTime" },
  { title: "P&L", dataIndex: "netProfit" },
  { title: "Position ID", dataIndex: "positionId" },
  { title: "Closed Count", dataIndex: "closeDealsCount" },
  { title: "Scalping Process", dataIndex: "isAlreadyDeducted" },
  { title: "Comment", dataIndex: "message" },
];

export default columns;

